import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Card, CardHeader, CardContent, Stack, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { SmallFormTextField } from '../../../../../../components-core/small-fields/SmallFormTextField';
import Level from './Level';

const ParticipantDataForm = ({ formik }) => {
  const { order } = useSelector(state => state.app);

  return (
    <Card>
      <CardHeader title="Dane uczestnika" sx={{ mt: -1, mb: -2 }} />
      <CardContent>
        <form onSubmit={formik.handleSubmit}>
          <Stack spacing={1}>
            {order.levels
              ? <Stack direction="row" spacing={2}>
                <FormControl sx={{ alignSelf: 'flex-start' }}>
                  <InputLabel id="select-label">Poziom</InputLabel>
                  <Select
                    name="level"
                    labelId="select-label"
                    value={formik.values.level}
                    label="Poziom"
                    onChange={formik.handleChange}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 250
                        }
                      }
                    }}
                  >
                    {order.all_levels.map(level => <MenuItem key={level.value} value={level.value}>{level.label}</MenuItem>)}
                  </Select>
                </FormControl>
                <Level levelDetails={order.level_details} />
              </Stack>
              : null}

            <Stack direction="column" alignItems="left" justifyContent="right" spacing={1}>
              <Typography variant="subtitle2">Stałe leki uczestnika</Typography>
              <SmallFormTextField
                name="participant_regular_medication"
                type="text"
                placeholder="stałe leki uczestnika"
                multiline
                rows={3}
                value={formik.values.participant_regular_medication}
                onChange={formik.handleChange}
              />
            </Stack>
            <Stack direction="column" alignItems="left" justifyContent="right" spacing={1}>
              <Typography variant="subtitle2">Osiągnięcia uczestnika</Typography>
              <SmallFormTextField
                name="achievements"
                type="text"
                placeholder="Osiągnięcia uczestnika"
                multiline
                rows={3}
                value={formik.values.achievements}
                onChange={formik.handleChange}
              />
            </Stack>
            <Stack direction="column" alignItems="left" justifyContent="right" spacing={1}>
              <Typography variant="subtitle2">Inne uwagi dotyczące uczestnika</Typography>
              <SmallFormTextField
                name="participant_other_comments"
                type="text"
                placeholder="inne uwagi dotyczące uczestnika"
                multiline
                rows={3}
                value={formik.values.participant_other_comments}
                onChange={formik.handleChange}
              />
            </Stack>
          </Stack>
        </form>
      </CardContent>
    </Card>
  );
};


export default ParticipantDataForm;
